import { NavItemType } from 'types/menu';

export function filterNavItemsByUserType(items: NavItemType[], userType: string | undefined): NavItemType[] {
  return items
    .map((item) => {
      const typeAllowed =
        !item.visibleForUserTypes?.length || (userType != null && item.visibleForUserTypes.includes(userType));

      if (!typeAllowed) {
        return null;
      }

      if (item.children?.length) {
        const filteredChildren = filterNavItemsByUserType(item.children, userType);
        if (item.type === 'group' && filteredChildren.length === 0) {
          return null;
        }
        return { ...item, children: filteredChildren };
      }

      return item;
    })
    .filter((item): item is NavItemType => item !== null);
}
